import { Component } from "react";
import styles from "./rich-product.module.less";
import { extract, ECommerceHelper, JetshopStore } from "@parksandresorts/core";
import UiBkgImage from "@rnb/ui-bkg-image";
import LinkWrapper from "components/block-elements/link-wrapper/link-wrapper";
import ProductPrice from "components/block-elements/product-price/product-price";

export default class RichProduct extends Component {
  constructor(props) {
    super(props);

    this._isMounted = false;

    this.imageUrl = extract(props, "productImage.file.url");
    this.name = extract(props, "productName");
    this.jetshopId = extract(props, "productData.jetshopId");
    this.shortDescription = extract(props, "shortDescription");
    this.link = extract(props, "productPageLink.slug");
    this.componentTheme = extract(props, "componentTheme");
    this.jetshopConfig = ECommerceHelper.getJetshopConfig();
    this.currencyDisplayName = this.jetshopConfig.currencyDisplayName;

    this.state = {
      price: undefined,
      previousPrice: undefined,
    };
  }

  componentDidMount() {
    this._isMounted = true;
    if (!this.jetshopId) {
      return;
    }

    JetshopStore.getExtendedProduct(this.jetshopId).then((product) => {
      if (!this._isMounted) {
        return;
      }

      this.setState({
        price: product.price,
        previousPrice: product.previousPrice,
      });
    });
  }

  componentWillUnmount() {
    this._isMounted = false;
  }

  render() {
    return (
      <div id={"id-" + this.props.contentful_id} className={styles.wrapper}>
        <LinkWrapper url={this.link} toOverlay={true}>
          <div className={styles.innerWrapper}>
            <div className={styles.imageWrapper}>
              <UiBkgImage
                className={styles.image}
                smallDeviceImageMaxWidth={600}
                largeDeviceImageMaxWidth={450}
                breakPointSmallDevice={9999}
                backgroundSizing="cover"
                imageUrlForSmallDevice={this.imageUrl}
                imageUrlForLargeDevice={this.imageUrl}
              />
            </div>
            <div className={styles.textWrapper}>
              <h5 className={styles.name}>{this.name}</h5>
              <p className={[styles.description, "body-s"].join(" ")}>{this.shortDescription}</p>
            </div>
            <div className={styles.priceWrapper}>
              <ProductPrice
                price={this.state.price}
                previousPrice={this.state.previousPrice}
                currencyDisplayName={this.currencyDisplayName}
                className={[
                  styles.priceInnerWrapper,
                  this.state.previousPrice > -1 ? styles.priceInnerWrapper_hasPreviousPrice : "",
                ].join(" ")}
                priceClassName={styles.price}
                previousPriceClassName={styles.previousPrice}
              />
              <span className={`waves-effect ${styles.button}`}>
                <span className="icon-chevron-right"></span>
              </span>
            </div>
          </div>
        </LinkWrapper>
      </div>
    );
  }
}
